import SearchRoadRoutingRequest, {
  SearchRoadRoutingRequestWaypointCoordinate,
} from "../../../utils/search-road-route/search-road-routing.request";
import MileageRoadRouteParams, {
  MileageRoadRouteParamsWaypoints,
} from "./mileage-road-route-params";

const changeWaypointType = (
  type: MileageRoadRouteParamsWaypoints,
): SearchRoadRoutingRequestWaypointCoordinate => {
  return {
    latitude: type.lat,
    longitude: type.lon,
  };
};

const create = (
  loadParams: MileageRoadRouteParams,
): SearchRoadRoutingRequest => {
  return {
    waypointCoordinates: loadParams.waypoints.map(changeWaypointType),
  };
};

const mileageRoadRouteParamsFactory = {
  create,
};

export default mileageRoadRouteParamsFactory;
